// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__SideBody__sideBody{height:100%;padding:var(--GW-LAYOUT-4) var(--GW-LAYOUT-4);width:100%}.jut__SideBody__sideBody:focus{outline:none}", "",{"version":3,"sources":["webpack://./../../../src/RightSideBar/SideBody/SideBody.module.scss","webpack://./../../platform/@jutro/router/RightSideBar/SideBody/SideBody.module.css"],"names":[],"mappings":"AAAA,yBACE,WAAA,CAEA,6CAAA,CADA,UCEF,CDCE,+BACE,YCCJ","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sideBody": "jut__SideBody__sideBody"
};
export default ___CSS_LOADER_EXPORT___;
